import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import '../assets/css/about.css';
import '../assets/css/psearch.css';
import SignInModal from './SignInModal';
import Nav from './Nav';
import SEO from './SEO';

function About() {
  const [user, setUser] = useState(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [activeTab, setActiveTab] = useState('yemberzal');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showSignInModal, setShowSignInModal] = useState(false);
  const [signInModalMessage, setSignInModalMessage] = useState('');
  const [authEmail, setAuthEmail] = useState('');
  const [authLoading, setAuthLoading] = useState(false);
  const [authMessage, setAuthMessage] = useState('');
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [publishForm, setPublishForm] = useState({
    name: '',
    email: '',
    articleTitle: '',
    articleSummary: '',
    articleLink: '',
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    const getSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
    };
    getSession();
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleGoogleSignIn = async () => {
    try {
      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/auth/callback`,
        },
      });
      
      if (error) {
        console.error('Error signing in:', error.message);
        setAuthMessage(`Sign in error: ${error.message}`);
      } else {
        console.log('OAuth initiated:', data);
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setAuthMessage(`Unexpected error: ${err.message}`);
    }
  };

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    if (!authEmail) return;
    
    setAuthLoading(true);
    setAuthMessage('');
    
    const { error } = await supabase.auth.signInWithOtp({
      email: authEmail,
      options: {
        emailRedirectTo: `${window.location.origin}/auth/callback`,
      },
    });
    
    if (error) {
      setAuthMessage(`Error: ${error.message}`);
    } else {
      setAuthMessage('Check your email for the magic link!');
    }
    setAuthLoading(false);
  };

  const handleEmailPasswordSignIn = async (email, password) => {
    setAuthLoading(true);
    setAuthMessage('');
    
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    
    if (error) {
      setAuthMessage(`Error: ${error.message}`);
    } else {
      setShowSignInModal(false);
    }
    setAuthLoading(false);
  };

  const handleEmailPasswordSignUp = async (email, password) => {
    setAuthLoading(true);
    setAuthMessage('');
    
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: `${window.location.origin}/auth/callback`,
        data: { user_role: 'general' },
      },
    });
    
    if (error) {
      setAuthMessage(`Error: ${error.message}`);
    } else {
      setAuthMessage('Check your email to confirm your account!');
    }
    setAuthLoading(false);
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    setShowUserDropdown(false);
  };

  // Yemberzal Team Blogs - Original content
  const yemberzalBlogs = [
    {
      title: "Yemberzal: A Love Letter to Kashmir, Written in <Code>",
      excerpt: "The story behind creating a platform to celebrate and preserve Kashmiri fashion heritage in the digital age.",
      date: "January 2026",
      author: "Yemberzal Team",
      tag: "Story",
      link: "https://buttoned-robe-004.notion.site/Yemberzal-A-love-letter-to-Kashmir-Written-in-Code-2f0b3231923b80a58173f364698e75cb"
    },
    // {
    //   title: "Why We Built Yemberzal",
    //   excerpt: "The story behind creating a platform to celebrate and preserve Kashmiri fashion heritage in the digital age.",
    //   date: "January 2026",
    //   author: "Yemberzal Team",
    //   tag: "Story",
    //   link: "#"
    // },
    // {
    //   title: "5 Ways to Style a Pashmina Shawl",
    //   excerpt: "From casual draping to elegant evening looks, discover versatile ways to wear this timeless Kashmiri staple.",
    //   date: "January 2026",
    //   author: "Yemberzal Team",
    //   tag: "Style Guide",
    //   link: "#"
    // },
    // {
    //   title: "The Art of Kani Weaving",
    //   excerpt: "A deep dive into the centuries-old technique that creates the intricate patterns of Kashmiri Kani shawls.",
    //   date: "Coming Soon",
    //   author: "Yemberzal Team",
    //   tag: "Craft",
    //   link: "#"
    // },
  ];

  // Featured Blogs - Curated from other authentic sources
  const featuredBlogs = [
    {
      title: "Kashmiri Pheran",
      excerpt: "The Timeless Elegance of Kashmiri Pherans: A Journey Through History and Culture",
      source: "Kashmiri Pheran",
      link: "https://www.kashmiripheran.com/blogs/news/the-timeless-elegance-of-kashmiri-pherans-a-journey-through-history-and-culture"
    },
    {
      title: "Kashmiri State Of Mind",
      excerpt: "New York City Pheran: A Kashmiri State of Mind - wearing tradition across continents.",
      source: "Mamanushka",
      link: "https://mamanushka.com/kashmiri-state-of-mind-new-york-city-pheran/"
    },
    {
      title: "The Enduring Legacy of Kashmiri Sozni Kari",
      excerpt: "An in-depth look at Kashmir's embroidery styles and their cultural significance.",
      source: "Pashmina.com",
      link: "https://www.pashmina.com/editorial/enduring-legacy-of-kashmiri-sozni-kari/"
    },
    {
      title: "The History of Pashmina",
      excerpt: "Tracing the origins of the world's finest wool from the high plateaus of Ladakh.",
      source: "Pashmina.com",
      link: "https://www.pashmina.com/editorial/history-of-pashmina/"
    },
    // {
    //   title: "Kashmiri Embroidery Techniques",
    //   excerpt: "From Aari to Sozni - exploring the diverse needlework traditions of Kashmir.",
    //   source: "Craft Stories",
    //   link: "#"
    // },
  ];

  return (
    <div className="container py-5 font-raleway">
      <SEO
        title="Blog — Kashmiri Fashion, Culture & Craftsmanship"
        description="Read about Kashmiri fashion, culture, and craftsmanship. Stories about pashmina weaving, aari embroidery, Kashmiri artisans, and the heritage behind every thread."
        path="/blog"
      />
      <Nav />

      {/* Hero Section */}
      <section className="py-5">
        <div className="page-hero-fullwidth" style={{ 
          backgroundColor: '#f5f5f5', 
          paddingTop: '40px',
          paddingBottom: '20px',
          marginBottom: '40px',
          textAlign: 'left',
        }}>
          <h1 style={{ fontSize: '3rem', fontWeight: 600, fontFamily: "'Montserrat', sans-serif", color: '#1a1a1a', marginBottom: '8px', letterSpacing: '0em' }}>
            B L O G
          </h1>
          <p style={{ fontSize: '16px', color: '#666', fontWeight: '300', maxWidth: '500px' }}>
            Stories, guides, and insights celebrating Kashmiri fashion
          </p>
        </div>
        <div style={{ textAlign: 'center' }}>
          <button
            onClick={() => setShowPublishModal(true)}
            style={{
              padding: '12px 28px',
              background: '#1a1a1a',
              color: '#fff',
              border: 'none',
              borderRadius: '25px',
              fontSize: '14px',
              fontWeight: '400',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#333'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#1a1a1a'; }}
          >
            Publish Your Article
          </button>
        </div>
      </section>

      {/* Tab Navigation */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: '0', 
        marginBottom: '48px',
        borderBottom: '1px solid #f0f0f0',
      }}>
        <button
          onClick={() => setActiveTab('yemberzal')}
          style={{
            padding: '16px 32px',
            background: 'transparent',
            border: 'none',
            borderBottom: activeTab === 'yemberzal' ? '2px solid #1a1a1a' : '2px solid transparent',
            color: activeTab === 'yemberzal' ? '#1a1a1a' : '#999',
            fontSize: '14px',
            fontWeight: '400',
            cursor: 'pointer',
            letterSpacing: '0.5px',
            marginBottom: '-1px',
            transition: 'all 0.2s',
          }}
        >
          From Yemberzal
        </button>
        <button
          onClick={() => setActiveTab('featured')}
          style={{
            padding: '16px 32px',
            background: 'transparent',
            border: 'none',
            borderBottom: activeTab === 'featured' ? '2px solid #1a1a1a' : '2px solid transparent',
            color: activeTab === 'featured' ? '#1a1a1a' : '#999',
            fontSize: '14px',
            fontWeight: '400',
            cursor: 'pointer',
            letterSpacing: '0.5px',
            marginBottom: '-1px',
            transition: 'all 0.2s',
          }}
        >
          Featured Reads
        </button>
      </div>

      {/* Yemberzal Team Blogs */}
      {activeTab === 'yemberzal' && (
        <section className="py-4">
          <div style={{ marginBottom: '32px' }}>
            {/* <p style={{ fontSize: '14px', color: '#888', fontWeight: '300' }}>
              Coming Soon
            </p> */}
          </div>
          <div className="row g-4">
            {yemberzalBlogs.map((blog, index) => (
              <div key={index} className="col-md-4">
                <a href={blog.link} className="text-decoration-none">
                  <div 
                    style={{
                      background: '#faf9f8',
                      borderRadius: '8px',
                      padding: '32px',
                      height: '100%',
                      transition: 'all 0.2s',
                      cursor: 'pointer',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f5f3f0'}
                    onMouseLeave={(e) => e.currentTarget.style.background = '#faf9f8'}
                  >
                    <div style={{ marginBottom: '16px' }}>
                      <span style={{
                        display: 'inline-block',
                        padding: '4px 12px',
                        background: '#1a1a1a',
                        color: '#fff',
                        fontSize: '11px',
                        fontWeight: '400',
                        borderRadius: '4px',
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                      }}>
                        {blog.tag}
                      </span>
                    </div>
                    <h3 style={{ fontSize: '18px', fontWeight: '500', color: '#1a1a1a', marginBottom: '12px', lineHeight: '1.4' }}>
                      {blog.title}
                    </h3>
                    <p style={{ fontSize: '14px', color: '#888', lineHeight: '1.6', marginBottom: '20px', fontWeight: '300' }}>
                      {blog.excerpt}
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: '12px', color: '#bbb' }}>{blog.date}</span>
                      <span style={{ fontSize: '13px', color: '#1a1a1a' }}>Read →</span>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Featured Blogs from Other Sources */}
      {activeTab === 'featured' && (
        <section className="py-4">
          <div style={{ marginBottom: '32px' }}>
            <p style={{ fontSize: '14px', color: '#888', fontWeight: '300' }}>
              Curated articles we find authentic and inspiring
            </p>
          </div>
          <div className="row g-4">
            {featuredBlogs.map((blog, index) => (
              <div key={index} className="col-md-6">
                <a href={blog.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                  <div 
                    style={{
                      background: '#fff',
                      border: '1px solid #f0f0f0',
                      borderRadius: '8px',
                      padding: '28px',
                      height: '100%',
                      transition: 'all 0.2s',
                      cursor: 'pointer',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#1a1a1a'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#f0f0f0'; }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                      <span style={{
                        fontSize: '11px',
                        color: '#999',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                      }}>
                        {blog.source}
                      </span>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2">
                        <path d="M7 17L17 7M17 7H7M17 7V17"/>
                      </svg>
                    </div>
                    <h3 style={{ fontSize: '17px', fontWeight: '500', color: '#1a1a1a', marginBottom: '10px', lineHeight: '1.4' }}>
                      {blog.title}
                    </h3>
                    <p style={{ fontSize: '14px', color: '#888', lineHeight: '1.6', margin: 0, fontWeight: '300' }}>
                      {blog.excerpt}
                    </p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Publish Article Modal */}
      {showPublishModal && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px',
          }}
          onClick={() => setShowPublishModal(false)}
        >
          <div 
            style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '40px',
              maxWidth: '500px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto',
              position: 'relative',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowPublishModal(false)}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#999',
              }}
            >
              ×
            </button>
            
            <h2 style={{ fontSize: '1.5rem', fontWeight: '400', marginBottom: '8px', color: '#1a1a1a' }}>
              Publish with Yemberzal
            </h2>
            <p style={{ fontSize: '14px', color: '#888', marginBottom: '24px' }}>
              Share your story about Kashmiri fashion, culture, or craftsmanship with our community.
            </p>

            {submitStatus === 'success' ? (
              <div style={{ textAlign: 'center', padding: '20px 0'  }}>
                <h3 style={{ fontSize: '18px', fontWeight: '500', marginBottom: '8px' }}>Thank you!</h3>
                <p style={{ color: '#888', fontSize: '14px' }}>
                  We've received your submission and will review it shortly.
                </p>
                <button
                  onClick={() => {
                    setShowPublishModal(false);
                    setSubmitStatus(null);
                    setPublishForm({ name: '', email: '', articleTitle: '', articleSummary: '', articleLink: '' });
                  }}
                  style={{
                    marginTop: '20px',
                    padding: '10px 24px',
                    background: '#1a1a1a',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                  }}
                >
                  Close
                </button>
              </div>
            ) : submitStatus === 'error' ? (
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <h3 style={{ fontSize: '18px', fontWeight: '500', marginBottom: '8px', color: '#dc3545' }}>Submission Failed</h3>
                <p style={{ color: '#888', fontSize: '14px' }}>
                  Something went wrong. Please try again or email us directly at contact@theyemberzal.com
                </p>
                <button
                  onClick={() => setSubmitStatus(null)}
                  style={{
                    marginTop: '20px',
                    padding: '10px 24px',
                    background: '#1a1a1a',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '25px',
                    cursor: 'pointer',
                  }}
                >
                  Try Again
                </button>
              </div>
            ) : (
              <form 
                onSubmit={async (e) => {
                  e.preventDefault();
                  setSubmitStatus('submitting');
                  
                  try {
                    const response = await fetch('https://script.google.com/macros/s/AKfycbzNomiszppbGbuhRY4iv2grnSxPVy9cu1OQgxdKOHSUefSzTre0KhsdsdxRPV-E6_9h/exec', {
                      method: 'POST',
                      mode: 'no-cors',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        name: publishForm.name,
                        email: publishForm.email,
                        articleTitle: publishForm.articleTitle,
                        articleSummary: publishForm.articleSummary,
                        articleLink: publishForm.articleLink || '',
                      }),
                    });
                    setSubmitStatus('success');
                  } catch (error) {
                    console.error('Submission error:', error);
                    setSubmitStatus('error');
                  }
                }}
              >
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px', color: '#1a1a1a' }}>
                    Your Name *
                  </label>
                  <input
                    type="text"
                    required
                    value={publishForm.name}
                    onChange={(e) => setPublishForm({ ...publishForm, name: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #e0e0e0',
                      borderRadius: '6px',
                      fontSize: '14px',
                      outline: 'none',
                    }}
                    placeholder="Enter your name"
                  />
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px', color: '#1a1a1a' }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    required
                    value={publishForm.email}
                    onChange={(e) => setPublishForm({ ...publishForm, email: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #e0e0e0',
                      borderRadius: '6px',
                      fontSize: '14px',
                      outline: 'none',
                    }}
                    placeholder="your@email.com"
                  />
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px', color: '#1a1a1a' }}>
                    Article Title *
                  </label>
                  <input
                    type="text"
                    required
                    value={publishForm.articleTitle}
                    onChange={(e) => setPublishForm({ ...publishForm, articleTitle: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #e0e0e0',
                      borderRadius: '6px',
                      fontSize: '14px',
                      outline: 'none',
                    }}
                    placeholder="What's your article about?"
                  />
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px', color: '#1a1a1a' }}>
                    Brief Summary *
                  </label>
                  <textarea
                    required
                    value={publishForm.articleSummary}
                    onChange={(e) => setPublishForm({ ...publishForm, articleSummary: e.target.value })}
                    rows={4}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #e0e0e0',
                      borderRadius: '6px',
                      fontSize: '14px',
                      outline: 'none',
                      resize: 'vertical',
                    }}
                    placeholder="Tell us what your article covers (2-3 sentences)"
                  />
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', marginBottom: '6px', color: '#1a1a1a' }}>
                    Article Link or Google Doc (optional)
                  </label>
                  <input
                    type="url"
                    value={publishForm.articleLink}
                    onChange={(e) => setPublishForm({ ...publishForm, articleLink: e.target.value })}
                    style={{
                      width: '100%',
                      padding: '12px',
                      border: '1px solid #e0e0e0',
                      borderRadius: '6px',
                      fontSize: '14px',
                      outline: 'none',
                    }}
                    placeholder="https://..."
                  />
                </div>

                <button
                  type="submit"
                  disabled={submitStatus === 'submitting'}
                  style={{
                    width: '100%',
                    padding: '14px',
                    background: submitStatus === 'submitting' ? '#ccc' : '#1a1a1a',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: submitStatus === 'submitting' ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s',
                  }}
                >
                  {submitStatus === 'submitting' ? 'Submitting...' : 'Submit Article'}
                </button>

                <p style={{ fontSize: '12px', color: '#999', marginTop: '16px', textAlign: 'center' }}>
                  We'll review your submission and get back to you within 3-5 days.
                </p>
              </form>
            )}
          </div>
        </div>
      )}

      <SignInModal
        open={showSignInModal}
        onClose={() => {
          setShowSignInModal(false);
          setAuthMessage('');
          setAuthEmail('');
          setSignInModalMessage('');
        }}
        message={signInModalMessage}
        authEmail={authEmail}
        setAuthEmail={setAuthEmail}
        authLoading={authLoading}
        authMessage={authMessage}
        onEmailSignIn={handleEmailSignIn}
        onGoogleSignIn={handleGoogleSignIn}
        onEmailPasswordSignIn={handleEmailPasswordSignIn}
        onEmailPasswordSignUp={handleEmailPasswordSignUp}
      />
    </div>
  );
}

export default About;

